export default interface BookAuditItem {
    id: number;
    filename: string;
    fromDate: string;
    toDate: string;
    user: number;
    userName: string;
    statusName: string;
    status: number;
    insDate: string;
    insTime: string;


    selected: boolean;
}
const now = new Date();

export const BookAuditItemDefaultProps: BookAuditItem = {
    id: 0,
    filename: "D:\\Audit.xml\\",
    fromDate: new Date(now.getFullYear(), now.getMonth(), 1)
        .toLocaleDateString('sv-SE'),

    toDate: new Date(now.getFullYear(), now.getMonth() + 1, 0)
        .toLocaleDateString('sv-SE'),
    insDate: new Date().toISOString().split('T')[0],
    insTime: new Date().toTimeString().split(' ')[0],
    statusName: "",
    status: 2,
    user: 0,
    userName: "",

    selected: false,
}